/**
 * @author       justin.jeong@zumper.com (Justin Jeong)
 * @copyright    Copyright (c) 2020, Zumper
 */

import { compose } from 'redux'

/**
 *
 * @param {import('@zcode/state-type').State} state
 * @returns
 */
export const selectPriceData = (state) => state && state.priceData

export const selectPriceDataRecentAverages = compose(
  (priceData) => priceData.recentAverages,
  selectPriceData
)

export const selectPriceDataYOYChange = compose((priceData) => priceData.yoyChange, selectPriceData)
